import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { first, takeUntil } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { formatDate } from '@angular/common';

import { VerificationDirective } from '../../../_common/_directives/verification.directive';
import { AfterViewInit } from '@angular/core';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ]
})

export class KycComponent implements OnInit, AfterViewInit {
  ipAddress: any;
  Idprooflist: any;
  idProofPERMIT: any;
  imgURLPERMIT: any = '';
  currentDate = new Date();
  submitted = false;
  imgURLId: any = '';
  idProofImage: any;
  warning: any;
  kycRemarkStatus: any;
  isLoggedIn = false;
  msg1: any;
  
  kycTypeStatus1: any;
  loadingspinner: boolean = false;
  btn: any;
  currentUser: any;
  public kycForm: FormGroup;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  countryList: any;
  signinusercountryIsdcode: any;
  flag: any;
  
  clientid = '6107d7c3a1eef7001b4acfa6';
  flowid = '6343fb0dc3f2cf001dcfc89f';
  metamapbutton: boolean = true;
  extraCreature: any;
  isDraggable: boolean =false;
 

  constructor(

    private ngxService: NgxUiLoaderService,
    public dialogRef: MatDialogRef<KycComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private toastr: ToastrService, private fb: FormBuilder,
    private authService: AuthService, private tokenStorageService: TokenStorageService, private withouttokenService: AuthenticationService,
    public datepipe: DatePipe
  ) {
    this.kycForm = this.fb.group({
      countryid: [null, [Validators.required]],
      KycType: [null, [Validators.required]],
      KycNumber: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(20), Validators.pattern("^[A-Za-z0-9]+(?:[-][A-Za-z0-9]+)*$")]],
      kycExpiry: [null, [Validators.required]],
      kycExpiry5: [null, [Validators.required]],
      address: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
      city: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
      state: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
      zipcode: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(20), Validators.pattern("^[A-Za-z0-9]+(?:[-][A-Za-z0-9]+)*$")]],
      USERDOB: [null, [Validators.required]],
      Gender: [null, [Validators.required]]
    })


  }

  @ViewChild(VerificationDirective)
  set appShark(directive: VerificationDirective) {
    debugger
    this.extraCreature = directive.movableObject;
  };

  ngAfterViewInit() {
    debugger
    ////////console.log('amit' + this.extraCreature);
    ////////console.log('amit1' + this.isDraggable);
  }

  ngOnInit() {
    debugger
   // //////console.log('amit2' + this.isDraggable);
    this.getIPAddress();
    this.btn = this.data;

    this.currentUser = this.tokenStorageService.getUser();
    this.getIsdCode();
    
    this.getIdprooflist();
    if (this.btn == 0) {
      this.f.countryid.enable();
      this.f.KycType.enable();
      this.f.KycNumber.enable();
      this.f.kycExpiry.enable();

      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });
      this.imgURLId = '../../../../../assets/Images/imgId.png';
      
    }


    else if (this.btn == 4) {
      this.getKYCUserDetails();
      
      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });

    }
    else {
      this.getKYCUserDetails();
      this.f.countryid.disable();
      this.f.KycType.disable();
      this.f.KycNumber.disable();
      this.f.kycExpiry.disable();
      
    }

  }

  get f() { return this.kycForm.controls; }

  upload() {

    this.submitted = true;

    if (this.btn == 0 || this.btn == 4) {
      
      if (!this.idProofImage) {

        this.msg1 = "No File Selected";
        
        return;
      }
      if (!this.idProofImage) {
        this.msg1 = "No File Selected";

        return;
      }
    }

    if (!this.idProofPERMIT && (this.f.kycExpiry5.value == "" || this.f.kycExpiry5.value == undefined)) {
      this.toastr.error("Enter Permit Expiry Date", 'Error');
      
      return;
    }

    
    if (this.kycForm.invalid) {

      return;
    }
    this.loadingspinner = true;
    var dt1 = this.datepipe.transform(this.f.kycExpiry.value, 'yyyy-MM-dd');
    var dt3 = this.datepipe.transform(this.f.USERDOB.value, 'dd-MM-yyyy');
    var dt5 = this.datepipe.transform(this.f.kycExpiry5.value, 'yyyy-MM-dd');

    let xx = new Date(this.f.kycExpiry.value);
    this.f.kycExpiry.setValue(xx);
    let xx1 = new Date(this.f.kycExpiry5.value);
    this.f.kycExpiry5.setValue(xx1);
    let xx2 = new Date(this.f.USERDOB.value);
    this.f.USERDOB.setValue(xx2);

    const formdata: FormData = new FormData();
    debugger
    if (this.idProofImage.type != undefined) {

      formdata.append("Image", this.idProofImage);
      formdata.append("ImageType", "IDPROOF");
      formdata.append("KycType", this.f.KycType.value);
      formdata.append("KycNumber", this.f.KycNumber.value);
      formdata.append("kycExpiry", dt1 ? dt1 : '');
      formdata.append("countryid", this.f.countryid.value);
      formdata.append("kycTypeStatus", "true");


    }

    if (this.idProofPERMIT.type != undefined) {

      formdata.append("Image", this.idProofPERMIT);
      formdata.append("ImageType", "WORKPERMIT");
      formdata.append("KycType", this.f.KycType.value); //change for if admin update front & back card//change by rohkit
      formdata.append("KycNumber", this.f.KycNumber.value);
      formdata.append("kycExpiry", dt5 ? dt5 : '');
      formdata.append("kycTypeStatus", "true");
      //formdata.append("kycTypeStatus", this.f.checkkyc4.value);
    }
    formdata.append("address", this.f.address.value);
    formdata.append("city", this.f.city.value);
    formdata.append("state", this.f.state.value);
    formdata.append("zipcode", this.f.zipcode.value);

    formdata.append("Username", this.currentUser.email);    
    formdata.append("IPAddress", this.ipAddress);
    formdata.append("USERDOB", dt3 ? dt3 : '');
    formdata.append("Gender", this.f.Gender.value);
    // 
    this.authService.uploadFile(formdata).subscribe(response => {
      this.loadingspinner = false;
      this.dialogRef.close();      
      this.idProofImage = '';
      this.imgURLId = '';

      this.imgURLPERMIT = '';
      this.idProofPERMIT = '';

      if (response.apiStatus == true) {
        this.toastr.success(response.apiMessage, 'Success');
        this.withouttokenService.updateMessagewithouttoken(this.currentUser);
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      this.dialogRef.close();
      this.loadingspinner = false;

      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getKYCUserDetails() {
    var Username = this.currentUser.email;

    this.authService.KYCUserDetails(Username).subscribe(response => {
      ////////console.log(response);
      debugger
      
      this.idProofImage = '';
      this.imgURLId = '';
      this.idProofPERMIT = '';
      this.imgURLPERMIT = '';

      if (response.apiStatus == true) {

        if (response.apiData.length == 0) {
          this.imgURLId = '../../../../../assets/Images/imgId.png';
          this.imgURLPERMIT = '../../../../../assets/Images/imgId.png';
        }
        else {

          this.warning = response.apiData[0].warning;
          this.kycRemarkStatus = response.apiData[0].kycRemarkStatus;

          this.imgURLId = '../../../../../assets/Images/imgId.png';
          this.imgURLPERMIT = '../../../../../assets/Images/imgId.png';

          for (var i = 0; i < response.apiData.length; i++) {

            if (response.apiData[i].kycMaster.doc_Name == 'IDPROOF') { //upload selfi
              this.imgURLId = response.apiData[i].doc_Path;

              var dt3 = this.datepipe.transform(response.apiData[i].expiry, 'yyyy-MM-dd');
              this.f.kycExpiry.setValue(dt3);
              let xx = new Date(this.f.kycExpiry.value);
              this.f.kycExpiry.setValue(xx);
              this.f.KycNumber.setValue(response.apiData[i].kycNumber);
              this.f.KycType.setValue(response.apiData[i].kycTypeId);
              this.f.countryid.setValue(response.apiData[i].countryId);


              this.f.address.setValue(response.apiData[i].address);
              this.f.city.setValue(response.apiData[i].city);
              this.f.state.setValue(response.apiData[i].state);
              this.f.zipcode.setValue(response.apiData[i].zipcode);

              this.kycTypeStatus1 = response.apiData[i].kycTypeStatus;
              debugger
              
              var date = new Date(response.apiData[i].dob.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))

              this.f.USERDOB.setValue(date);
              this.f.Gender.setValue(response.apiData[i].gender);
              
              if (this.kycTypeStatus1 == true) {
                this.idProofImage = response.apiData[i].doc_Path;
                this.f.countryid.disable();
                this.f.KycType.disable();
                this.f.KycNumber.disable();
                this.f.kycExpiry.disable();
              }
              else {
                this.f.countryid.enable();
                this.f.KycType.enable();
                this.f.KycNumber.enable();
                this.f.kycExpiry.enable();
              

              }
            }


            if (response.apiData[i].kycMaster.doc_Name == 'WORKPERMIT') {

              this.imgURLPERMIT = response.apiData[i].doc_Path;
              this.idProofPERMIT = response.apiData[i].doc_Path;
              var dt5 = this.datepipe.transform(response.apiData[i].expiry, 'yyyy-MM-dd');
              this.f.kycExpiry5.setValue(dt5);
              let xx = new Date(this.f.kycExpiry5.value);
              this.f.kycExpiry5.setValue(xx);
              this.f.kycExpiry5.disable();
            }


          }


          if (this.kycTypeStatus1 == true) {
            this.flag = false;

          }
          else {
            this.flag = true;

          }


        }
      }
      else {
        this.toastr.error(response.error + response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  preview(files: any, type: any) {

    if (files.length === 0) {
      this.toastr.error('No file', 'Error');
      return;
    }

    if (files[0].size > 50000000) {
      this.toastr.error('maximum file size of 50MB', 'Error');
      return;
    }

    const URL = window.URL || window.webkitURL;
    const Img = new Image();

    Img.src = URL.createObjectURL(files[0]);

    if (files[0].type === 'image/jpeg' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
      // if (event.target.files[0].size < 200 * 200) {/* Checking height * width*/ }
      // if (event.target.files[0].size < 2000000) {/* checking size here - 2MB */ }

      if (type === 1) {

        this.idProofImage = files[0];
        this.imgURLId = '';

      }
      else if (type === 5) {

        this.idProofPERMIT = files[0];
        this.imgURLPERMIT = '';
      }
      var reader = new FileReader();
      //this.imagePath = files;      

      reader.readAsDataURL(files[0]);
      reader.onload = (e: any) => {

        Img.onload = (e: any) => {

          ////////console.log('e' + e);
          const height = e.path[0].height;
          const width = e.path[0].width;

          if (type === 1) {
            this.imgURLId = reader.result;

          }
          else if (type === 5) {


            this.imgURLPERMIT = reader.result;
          }
        }
      }
    }
    else {
      this.toastr.error('Only images are supported.', 'Error');
      return;
    }

  }


  getIdprooflist() {


    this.authService.KYClist(1).subscribe(response => {


      if (response) {
        this.Idprooflist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }


    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  

  getIsdCode() {

    this.submitted = true;
    this.authService.getOtpIsdCode().subscribe((response: { isSuccess: any; result: any; Message: any; }) => {

      this.countryList = response;

    }, (err: any) => {
      this.toastr.error(err.error, 'Error');
    }
    );
  }
  filterCountry() {

    if (this.CountryFilterCtrl.value) {

      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }
  getIPAddress() {
    const response = fetch('https://api.ipify.org/?format=json')
      .then(response => response.json())
      .then(data => {
        this.ipAddress = data.ip;
      });

  }

}



/*kyc old below version change to mati sdk above*/
//export class KycComponent implements OnInit {
//  ipAddress: any;
//  Idprooflist: any;
//  Cardprooflist: any;
//  currentDate = new Date();
//  submitted = false;

//  imgURLCard: any = '';
//  imgURLId: any = '';
//  imgURLIdback: any = '';
//  imgURLIdfnt: any = '';

//  cardImage: any;
//  idProofImage: any;

//  IdCrDeImagefnt: any;
//  IdCrDeImageBACK: any;

//  warning: any;
//  kycRemarkStatus: any;

//  isLoggedIn = false;
//  msg1: any;
//  msg2: any;
//  msg3: any;
//  msg4: any;

//  kycTypeStatus1: any;
//  kycTypeStatus2: any;
//  kycTypeStatus3: any;
//  kycTypeStatus4: any;
//  loadingspinner: boolean = false;
//  btn: any;
//  currentUser: any;
//  public kycForm: FormGroup;

//  public CountryFilterCtrl: FormControl = new FormControl();
//  protected _onDestroy = new Subject<void>();
//  countryList: any;
//  signinusercountryIsdcode: any;
//  flag: any;

//  constructor(
//    private ngxService: NgxUiLoaderService,
//    //private readonly adapter: DateAdapter<Date>,
//    public dialogRef: MatDialogRef<KycComponent>,
//    @Inject(MAT_DIALOG_DATA) public data: any,
//    private toastr: ToastrService, private fb: FormBuilder,
//    private authService: AuthService, private tokenStorageService: TokenStorageService, private withouttokenService: AuthenticationService,
//    public datepipe: DatePipe
//  ) {
//    //this.adapter.setLocale('en-GB'); //dd/MM/yyyy
//    //this.adapter.format(this.currentDate, "MM-yyyy");
//    //this.signinusercountryIsdcode = localStorage.getItem('countryIsdcode1');
//    this.kycForm = this.fb.group({
//      countryid: [null, [Validators.required]],
//      KycType: [null, [Validators.required]],
//      KycNumber: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(20), Validators.pattern("^[A-Za-z0-9]+(?:[-][A-Za-z0-9]+)*$")]],
//      kycExpiry: [null, [Validators.required]],
//      KycType1: [null, [Validators.required]],
//      CardNumber: [null, [Validators.required, Validators.minLength(19)]],
//      kycExpiry1: [null, [Validators.required]],
//      address: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
//      city: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
//      state: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern("^[A-Za-z0-9-./]+(?:[ -][A-Za-z0-9-./]+)*$")]],
//      zipcode: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(20), Validators.pattern("^[A-Za-z0-9]+(?:[-][A-Za-z0-9]+)*$")]],
//      USERDOB: [null, [Validators.required]],
//      Gender: [null, [Validators.required]]
//    })
//  }

//  ngOnInit() {
//    //if (this.signinusercountryIsdcode == '+1') {
//    //  this.f.zipcode.setValue(null);
//    //  this.f.zipcode.setValidators([
//    //    Validators.required, Validators.minLength(3), Validators.maxLength(20), Validators.pattern("^[0-9a-zA-Z]*$")
//    //  ]);
//    //}

//    this.getIPAddress();
//    this.btn = this.data;

//    this.currentUser = this.tokenStorageService.getUser();
//    this.getIsdCode();
//    this.getCardprooflist();
//    this.getIdprooflist();
//    if (this.btn == 0) {
//      this.f.countryid.enable();
//      this.f.KycType.enable();
//      this.f.KycNumber.enable();
//      this.f.kycExpiry.enable();


//      this.f.KycType1.enable();
//      this.f.CardNumber.enable();
//      this.f.kycExpiry1.enable();


//      // listen for search field value changes
//      this.CountryFilterCtrl.valueChanges
//        .pipe(takeUntil(this._onDestroy))
//        .subscribe(() => {
//          this.filterCountry();
//        });
//      this.imgURLId = '../../../../../assets/Images/imgId.png';
//      this.imgURLCard = '../../../../../assets/Images/imgId.png';
//      this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//      this.imgURLIdback = '../../../../../assets/Images/back.png';
//    }


//    else if (this.btn == 4) {
//      this.getKYCUserDetails();
//      //this.f.countryid.enable();
//      //this.f.KycType.enable();
//      //this.f.KycNumber.enable();
//      //this.f.kycExpiry.enable();


//      //this.f.KycType1.enable();
//      //this.f.CardNumber.enable();
//      //this.f.kycExpiry1.enable();


//      // listen for search field value changes
//      this.CountryFilterCtrl.valueChanges
//        .pipe(takeUntil(this._onDestroy))
//        .subscribe(() => {
//          this.filterCountry();
//        });

//    }
//    else {
//      this.getKYCUserDetails();
//      this.f.countryid.disable();
//      this.f.KycType.disable();
//      this.f.KycNumber.disable();
//      this.f.kycExpiry.disable();

//      this.f.KycType1.disable();
//      this.f.CardNumber.disable();
//      this.f.kycExpiry1.disable();
//    }

//  }

//  get f() { return this.kycForm.controls; }


//  transform() {
//    let transformValue = this.f.CardNumber.value;

//    if (transformValue && transformValue.length > 0) {
//      let chIbn = transformValue.split('-').join('');
//      if (chIbn.length > 0) {
//        chIbn = chIbn.match(new RegExp('.{1,4}', 'g')).join('-');
//      }

//      this.f.CardNumber.setValue(chIbn);
//    }
//  }



//  upload() {

//    this.submitted = true;

//    if (this.btn == 0 || this.btn == 4) {
//      //if (this.btn == 0) {
//      if (!this.cardImage && !this.idProofImage && !this.IdCrDeImagefnt && !this.IdCrDeImageBACK) {

//        this.msg1 = "No File Selected";
//        this.msg2 = "No File Selected";
//        this.msg3 = "No File Selected";
//        this.msg4 = "No File Selected";

//        return;
//      }
//      if (!this.cardImage) {
//        this.msg2 = "No File Selected";

//        return;
//      }
//      if (!this.idProofImage) {
//        this.msg1 = "No File Selected";

//        return;
//      }
//      if (!this.IdCrDeImagefnt) {
//        this.msg3 = "No File Selected";

//        return;
//      }
//      if (!this.IdCrDeImageBACK) {
//        this.msg4 = "No File Selected";

//        return;
//      }

//    }


//    if ((this.IdCrDeImagefnt.type != undefined && this.IdCrDeImageBACK.type == undefined) || (this.IdCrDeImagefnt.type == undefined && this.IdCrDeImageBACK.type != undefined)) {
//      //this.msg4 = "Front & Back File Required";
//      this.toastr.error("Front & Back File Required", 'Error');

//      return;
//    }

//    if (this.kycForm.invalid) {

//      return;
//    }
//    this.loadingspinner = true;
//    var dt1 = this.datepipe.transform(this.f.kycExpiry.value, 'yyyy-MM-dd');
//    var dt2 = this.datepipe.transform(this.f.kycExpiry1.value, 'yyyy-MM-dd');
//    debugger;
//    var dt3 = this.datepipe.transform(this.f.USERDOB.value, 'dd-MM-yyyy');

//    let xx = new Date(this.f.kycExpiry.value);
//    this.f.kycExpiry.setValue(xx);
//    let xx1 = new Date(this.f.kycExpiry1.value);
//    this.f.kycExpiry1.setValue(xx1);
//    let xx2 = new Date(this.f.USERDOB.value);
//    this.f.USERDOB.setValue(xx2);

//    const formdata: FormData = new FormData();
//    debugger
//    if (this.idProofImage.type != undefined) {

//      formdata.append("Image", this.idProofImage);
//      formdata.append("ImageType", "IDPROOF");
//      formdata.append("KycType", this.f.KycType.value);
//      formdata.append("KycNumber", this.f.KycNumber.value);
//      formdata.append("kycExpiry", dt1 ? dt1 : '');
//      formdata.append("countryid", this.f.countryid.value);
//      formdata.append("kycTypeStatus", "true");


//    }
//    if (this.cardImage.type != undefined) {
//      formdata.append("Image", this.cardImage);
//      formdata.append("ImageType", "CARD");
//      formdata.append("KycType", this.f.KycType1.value);
//      formdata.append("KycNumber", this.f.CardNumber.value);
//      formdata.append("kycExpiry", dt2 ? dt2 : '');
//      formdata.append("kycTypeStatus", "true");

//    }
//    if (this.IdCrDeImagefnt.type != undefined) {

//      formdata.append("Image", this.IdCrDeImagefnt);
//      formdata.append("ImageType", "IDCARD");

//      formdata.append("KycType", this.f.KycType.value); //change for if admin update front & back card//change by rohkit
//      formdata.append("KycNumber", this.f.KycNumber.value);
//      formdata.append("kycExpiry", dt1 ? dt1 : '');
//      formdata.append("kycTypeStatus", "true");
//    }
//    if (this.IdCrDeImageBACK.type != undefined) {

//      formdata.append("Image", this.IdCrDeImageBACK);
//      formdata.append("ImageType", "IDBACK");
//      formdata.append("KycType", this.f.KycType.value); //change for if admin update front & back card//change by rohkit
//      formdata.append("KycNumber", this.f.KycNumber.value);
//      formdata.append("kycExpiry", dt1 ? dt1 : '');
//      formdata.append("kycTypeStatus", "true");
//    }


//    formdata.append("address", this.f.address.value);
//    formdata.append("city", this.f.city.value);
//    formdata.append("state", this.f.state.value);
//    formdata.append("zipcode", this.f.zipcode.value);

//    formdata.append("Username", this.currentUser.email);
//    formdata.append("IPAddress", this.ipAddress);
//    formdata.append("USERDOB", dt3 ? dt3 : '');
//    formdata.append("Gender", this.f.Gender.value);
//    // 
//    this.authService.uploadFile(formdata).subscribe(response => {
//      this.loadingspinner = false;

//      this.dialogRef.close();
//      this.cardImage = '';
//      this.idProofImage = '';
//      this.IdCrDeImagefnt = '';
//      this.IdCrDeImageBACK = '';
//      this.imgURLIdfnt = '';
//      this.imgURLIdback = '';
//      this.imgURLCard = '';
//      this.imgURLId = '';

//      if (response.apiStatus == true) {
//        this.toastr.success(response.apiMessage, 'Success');
//        this.withouttokenService.updateMessagewithouttoken(this.currentUser);
//      } else {
//        this.toastr.error(response.apiMessage, 'Error');
//      }
//    }, (err: any) => {
//      this.dialogRef.close();
//      this.loadingspinner = false;

//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    });
//  }

//  getKYCUserDetails() {
//    var Username = this.currentUser.email;

//    this.authService.KYCUserDetails(Username).subscribe(response => {
//      //////console.log(response);
//      debugger
//      this.cardImage = '';
//      this.idProofImage = '';
//      this.IdCrDeImagefnt = '';
//      this.IdCrDeImageBACK = '';
//      this.imgURLIdfnt = '';
//      this.imgURLIdback = '';
//      this.imgURLCard = '';
//      this.imgURLId = '';

//      if (response.apiStatus == true) {

//        if (response.apiData.length == 0) {
//          this.imgURLId = '../../../../../assets/Images/imgId.png';
//          this.imgURLCard = '../../../../../assets/Images/imgId.png';
//          this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//          this.imgURLIdback = '../../../../../assets/Images/back.png';
//        }
//        else {

//          this.warning = response.apiData[0].warning;
//          this.kycRemarkStatus = response.apiData[0].kycRemarkStatus;

//          //if (response.apiData[0].kycId == 1) {
//          //  this.imgURLId = response.apiData[0].doc_Path;

//          //  var dt3 = this.datepipe.transform(response.apiData[0].expiry, 'yyyy-MM-dd');
//          //  this.f.kycExpiry.setValue(dt3);
//          //  this.f.KycNumber.setValue(response.apiData[0].kycNumber);
//          //  this.f.KycType.setValue(response.apiData[0].kycTypeId);
//          //  this.f.countryid.setValue(response.apiData[0].countryId);


//          //}
//          //else {
//          //  this.imgURLId = '../../../../../assets/Images/imgId.png';
//          //}
//          //if (response.apiData[1].kycId == 2) { //debit/credit card
//          //  this.imgURLCard = response.apiData[1].doc_Path;
//          //  var dt2 = this.datepipe.transform(response.apiData[1].expiry, 'yyyy-MM-dd');

//          //  this.f.kycExpiry1.setValue(dt2);
//          //  this.f.KycType1.setValue(response.apiData[1].kycTypeId);
//          //  this.f.CardNumber.setValue(response.apiData[1].kycNumber);
//          //}
//          //else {
//          //  this.imgURLCard = '../../../../../assets/Images/imgId.png';
//          //}

//          //if (response.apiData[2].kycId == 4) {
//          //  this.imgURLIdfnt = response.apiData[2].doc_Path;
//          //}
//          //else {
//          //  this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//          //}

//          //if (response.apiData[3].kycId == 5) {
//          //  this.imgURLIdback = response.apiData[3].doc_Path;
//          //}
//          //else {
//          //  this.imgURLIdback = '../../../../../assets/Images/back.png';
//          //}


//          this.imgURLId = '../../../../../assets/Images/imgId.png';
//          this.imgURLCard = '../../../../../assets/Images/imgId.png';
//          this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//          this.imgURLIdback = '../../../../../assets/Images/back.png';
//          ;
//          for (var i = 0; i < response.apiData.length; i++) {

//            if (response.apiData[i].kycMaster.doc_Name == 'IDPROOF') { //upload selfi
//              this.imgURLId = response.apiData[i].doc_Path;

//              var dt3 = this.datepipe.transform(response.apiData[i].expiry, 'yyyy-MM-dd');
//              this.f.kycExpiry.setValue(dt3);
//              let xx = new Date(this.f.kycExpiry.value);
//              this.f.kycExpiry.setValue(xx);
//              this.f.KycNumber.setValue(response.apiData[i].kycNumber);
//              this.f.KycType.setValue(response.apiData[i].kycTypeId);
//              this.f.countryid.setValue(response.apiData[i].countryId);


//              this.f.address.setValue(response.apiData[i].address);
//              this.f.city.setValue(response.apiData[i].city);
//              this.f.state.setValue(response.apiData[i].state);
//              this.f.zipcode.setValue(response.apiData[i].zipcode);

//              this.kycTypeStatus1 = response.apiData[i].kycTypeStatus;
//              debugger

//              var date = new Date(response.apiData[i].dob.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))

//              this.f.USERDOB.setValue(date);
//              this.f.Gender.setValue(response.apiData[i].gender);

//              if (this.kycTypeStatus1 == true) {
//                this.idProofImage = response.apiData[i].doc_Path;
//                this.f.countryid.disable();
//                this.f.KycType.disable();
//                this.f.KycNumber.disable();
//                this.f.kycExpiry.disable();
//              }
//              else {
//                this.f.countryid.enable();
//                this.f.KycType.enable();
//                this.f.KycNumber.enable();
//                this.f.kycExpiry.enable();


//              }
//            }

//            if (response.apiData[i].kycMaster.doc_Name == 'CARD') { //debit/credit card
//              this.imgURLCard = response.apiData[i].doc_Path;
//              var dt2 = this.datepipe.transform(response.apiData[i].expiry, 'yyyy-MM-dd');

//              this.f.kycExpiry1.setValue(dt2);
//              let xx = new Date(this.f.kycExpiry1.value);
//              this.f.kycExpiry1.setValue(xx);

//              this.f.KycType1.setValue(response.apiData[i].kycTypeId);
//              this.f.CardNumber.setValue(response.apiData[i].kycNumber);

//              this.kycTypeStatus2 = response.apiData[i].kycTypeStatus;
//              if (this.kycTypeStatus2 == true) {
//                this.cardImage = response.apiData[i].doc_Path;

//                this.f.KycType1.disable();
//                this.f.CardNumber.disable();
//                this.f.kycExpiry1.disable();
//              }
//              else {
//                this.f.KycType1.enable();
//                this.f.CardNumber.enable();
//                this.f.kycExpiry1.enable();


//              }

//            }

//            if (response.apiData[i].kycMaster.doc_Name == 'IDCARD') {
//              this.imgURLIdfnt = response.apiData[i].doc_Path;

//              this.kycTypeStatus3 = response.apiData[i].kycTypeStatus;
//              if (this.kycTypeStatus3 == true) {
//                this.IdCrDeImagefnt = response.apiData[i].doc_Path;
//              }
//            }

//            if (response.apiData[i].kycMaster.doc_Name == 'IDBACK') {
//              this.imgURLIdback = response.apiData[i].doc_Path;
//              this.kycTypeStatus4 = response.apiData[i].kycTypeStatus;
//              if (this.kycTypeStatus4 == true) {
//                this.IdCrDeImageBACK = response.apiData[i].doc_Path;
//              }
//            }

//          }


//          if (this.kycTypeStatus1 == true && this.kycTypeStatus2 == true && this.kycTypeStatus3 == true && this.kycTypeStatus4 == true) {
//            this.flag = false;

//          }
//          else {
//            this.flag = true;

//          }


//        }
//      }
//      else {
//        this.toastr.error(response.error + response.apiMessage, 'Error');
//      }
//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    });
//  }

//  preview(files: any, type: any) {

//    if (files.length === 0) {
//      this.toastr.error('No file', 'Error');
//      return;
//    }

//    if (files[0].size > 50000000) {
//      this.toastr.error('maximum file size of 50MB', 'Error');
//      return;
//    }

//    const URL = window.URL || window.webkitURL;
//    const Img = new Image();

//    Img.src = URL.createObjectURL(files[0]);

//    if (files[0].type === 'image/jpeg' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
//      // if (event.target.files[0].size < 200 * 200) {/* Checking height * width*/ }
//      // if (event.target.files[0].size < 2000000) {/* checking size here - 2MB */ }

//      if (type === 1) {

//        this.idProofImage = files[0];
//        this.imgURLId = '';

//      }
//      else if (type === 2) {
//        this.cardImage = files[0];
//        ////////console.log(files[0]);
//        this.imgURLCard = '';
//      }
//      else if (type === 3) {

//        this.IdCrDeImagefnt = files[0];
//        this.imgURLIdfnt = '';
//      }
//      else if (type === 4) {


//        this.IdCrDeImageBACK = files[0];
//        this.imgURLIdback = '';
//      }

//      var reader = new FileReader();
//      //this.imagePath = files;      

//      reader.readAsDataURL(files[0]);
//      reader.onload = (e: any) => {

//        Img.onload = (e: any) => {

//          ////////console.log('e' + e);
//          const height = e.path[0].height;
//          const width = e.path[0].width;

//          if ((type === 3 && height < 600) || (type === 4 && height < 600)) {

//            if (type === 3) {

//              this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//              this.toastr.error('minimum height resolution of 600 pixels', 'Error');
//              return;
//            }
//            else if (type === 4) {
//              this.imgURLIdback = '../../../../../assets/Images/back.png';
//              this.toastr.error('minimum height resolution of 600 pixels', 'Error');
//              return;

//            }
//          }

//          //width
//          if ((type === 3 && width < 600) || (type === 4 && width < 600)) {

//            if (type === 3) {

//              this.imgURLIdfnt = '../../../../../assets/Images/fn.png';
//              this.toastr.error('minimum width resolution of 600 pixels', 'Error');
//              return;

//            }
//            else if (type === 4) {
//              this.imgURLIdback = '../../../../../assets/Images/back.png';
//              this.toastr.error('minimum width resolution of 600 pixels', 'Error');
//              return;
//            }
//          }

//          if (type === 1) {
//            this.imgURLId = reader.result;

//          }
//          else if (type === 2) {
//            this.imgURLCard = reader.result;
//          }
//          else if (type === 3) {

//            this.imgURLIdfnt = reader.result;
//          }
//          else if (type === 4) {


//            this.imgURLIdback = reader.result;

//          }
//        }
//      }
//    }
//    else {
//      this.toastr.error('Only images are supported.', 'Error');
//      return;
//    }

//  }


//  getIdprooflist() {


//    this.authService.KYClist(1).subscribe(response => {


//      if (response) {
//        this.Idprooflist = response;
//      }
//      else {
//        this.toastr.error('Error', 'Error');
//      }


//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    });
//  }

//  getCardprooflist() {


//    this.authService.KYClist(2).subscribe(response => {

//      ;
//      if (response) {
//        this.Cardprooflist = response;
//      }
//      else {
//        this.toastr.error('Error', 'Error');
//      }
//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    });
//  }

//  getIsdCode() {

//    this.submitted = true;
//    this.authService.getOtpIsdCode().subscribe((response: { isSuccess: any; result: any; Message: any; }) => {

//      this.countryList = response;

//    }, (err: any) => {
//      this.toastr.error(err.error, 'Error');
//    }
//    );
//  }
//  filterCountry() {

//    if (this.CountryFilterCtrl.value) {

//      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
//    } else {
//      return this.countryList;
//    }
//  }
//  getIPAddress() {
//    const response = fetch('https://api.ipify.org/?format=json')
//      .then(response => response.json())
//      .then(data => {
//        this.ipAddress = data.ip;
//      });

//  }

//}
